import { Suspense, lazy, useEffect, useState } from "react";
import { Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"

import { Link } from "react-router-dom";
import swal from "sweetalert";
import Pagination from "react-js-pagination";
import EventBus from "../../../services/EventBus";
import { GetAllTenants, GetInstructors } from "../../../services/CommonService";
import AddInstructors from "./AddInstructors";



const Instructors = () => {

    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );

    useEffect(() => {
        getAllStates();
        getTenants();

        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");

    }, []);

    const [Instructor, setInstructor] = useState([]);
    const [postModal, setPostModal] = useState(false);
    const [tenantlist, setTenantList] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0)
    const [updatedata, setUpdateData] = useState({});
    const [modaltype, setModalType] = useState('0');
    const [postModal1, setPostModal1] = useState(false);
    const [districtData, setDistrictData] = useState(false);
    const [districtDataType, setDistrictDataType] = useState(null);
    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn
        }
        const respData = await GetInstructors(reqparams);
        setInstructor(respData?.data?.docs);
        setTotalRecords(respData.data.totalDocs);
    }


    const getAllStates = async () => {
        const reqparams = {
            pageno: '1'
        }
        const respData = await GetInstructors(reqparams);
        setInstructor(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);
    }

    const getTenants = async () => {

        const reqdata = {
            pageno: '-1',
            query: { status: 'Active' }
        }

        const Response = await GetAllTenants(reqdata)
        let counter = 0;
        const rowdata = [];
        await Response.data.reduce(async (promise, res) => {
            await promise;
            const opts = {
                label: res.name,
                value: res.tenantid
            }
            rowdata.push(opts);
            if (counter == Response.data.length - 1) {

                setTenantList(rowdata);
            }
            counter++;
        }, Promise.resolve());

    }

    // console.log(tenantlist);

    const openModal = async (type, item) => {
        // console.log(type);
        setModalType(type);
        console.log(item);
        setUpdateData(item);
        setPostModal(true);
    }
    const addModal = async (type) => {
        setModalType(type);
        setUpdateData({});
        setPostModal(true);
    }
    const closemodal = async () => {
        getAllStates();
        setPostModal(false);
    }
    const openDistrictModal = async (item) => {
        setDistrictData(item);
        setDistrictDataType('DISTRICT');
        setPostModal1(true);
    }
    const closemodal1 = async () => {
        setPostModal1(false);
    }

    const deleteRow = async (id) => {
        const data = {
            id: id
        }

        // const response = await deletePricing(data);


        /* if (response.status != 'success') {
             swal( "Failed to update data", "failure")
         } else {
           // notifyTopInfo("Profile data updated successfully");
           swal("Data updated successfully", "success")
           getPricings();
            
         } */

    }



    return (
        <>
            <Col lg={12}>
                <Card>
                    <Card.Header>
                        <Card.Title>Instructor <Button onClick={() => addModal('1')}
                            className="me-2" variant="primary btn-square"
                            title="Add State"
                        >
                            <span className="btn-icon-start text-danger">
                                <i className="fa fa-plus color-danger" />
                            </span>
                            ADD
                        </Button></Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>
                                        <strong>Position</strong>
                                    </th>

                                    <th>
                                        <strong>Instructor Name</strong>
                                    </th>
                                    <th>
                                        <strong>Tenants</strong>
                                    </th>
                                    <th>
                                        <strong>Image</strong>
                                    </th>
                                    <th>
                                        <strong>status</strong>
                                    </th>

                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Instructor?.map(item => (
                                    <tr>
                                        <td>{item.position}</td>
                                        <td>{item.name}</td>
                                        <td>{displayTenants(item.tenant)}</td>
                                        <td>
                                            <img style={{ "height": "100px" }}
                                                src={item.image} alt="Red dot" />
                                        </td>
                                        <td>{item.status}</td>
                                        <td></td>

                                        <td>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    className="light sharp i-false"
                                                >
                                                    {svg1}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => openModal('1', item)}>
                                                        Edit

                                                    </Dropdown.Item >


                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                        <div >

                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={10}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                activeClass="active"
                                itemClass="page-item"
                                innerClass="pagination mb-0"
                                linkClass="page-link"
                                firstPageText="First"
                                lastPageText="Last"
                                prevPageText="Previous"
                                nextPageText="Next"
                                disabledClass="disabled"
                                activeLinkClass="disabled"
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">
                                {modaltype == '2' && <>{updatedata.name}</>}
                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">



                                {
                                    modaltype == '1' ? (
                                        <Suspense fallback={<div>Loading</div>}>
                                            {/* <AddState tenantprops={tenantlist} updateprop ={updatedata} />  */}
                                            <AddInstructors tenantprops={tenantlist} updateprop={updatedata} />
                                        </Suspense>

                                    )
                                        : null

                                }

                            </div>
                            {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
                        </form>

                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" size="xl" show={postModal1} onHide={setPostModal1} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal1} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">


                                <Suspense fallback={<div>Loading</div>}>
                                    {/* <AddDistrict courseprops={districtData} programtype ={districtDataType} />  */}
                                </Suspense>


                            </div>
                            {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
                        </form>

                    </div>
                </div>
            </Modal>
        </>
    )
}

function displayTenants(item) {


    let counter = 0;
    let retdata = '';
    for (var j = 0; j < item.length; j++) {

        // console.log(item[j]);
        if (retdata == '') {
            retdata = item[j].label;
        } else {
            retdata = retdata + ',' + item[j].label;
        }
        if (counter == item.length - 1) {
            return retdata;
        }

        counter++;

    }
}

export default Instructors